<template>
  <div>
    <div
      v-for="(snippet, index) in templateSnippets"
      :key="index"
      class="chosen-snippet-item"
    >
      <span>{{ snippet.title }}</span>
      <span
        class="remove-snippet far fa-trash-alt"
        @click="removeSnippet(snippet._id)"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('graphicsTemplate', ['getTemplateSnippets']),
    templateSnippets() {
      const snippetIds = this.getTemplateSnippets;
      const { snippets } = this.$store.state.user;
      const out = [];

      snippets.forEach((snippet) => {
        // TODO: refactor bitwise
        // eslint-disable-next-line no-bitwise
        if (~snippetIds.indexOf(snippet._id)) {
          out.push(snippet);
        }
      });

      return out;
    },
  },
  methods: {
    ...mapActions('graphicsTemplate', ['removeTemplateSnippet']),
    removeSnippet(snippetId) {
      // They removed a snippet, remove it from the template
      this.removeTemplateSnippet({ value: snippetId });
    },
  },
};
</script>
